"use strict";

exports.__esModule = true;
exports.wrapRootElement = void 0;

var _wrapElement = require("./wrap-element");

var wrapRootElement = function wrapRootElement(_ref) {
  var element = _ref.element;
  return (0, _wrapElement.wrapElement)(element);
};

exports.wrapRootElement = wrapRootElement;